import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { getSeoMetadata } from "../../config/seo.config";

// อัปเดต metadata ตาม URL ปัจจุบัน โดย public route ใช้ canonical ส่วน route อื่นใช้ noindex
const SeoMetadata = () => {
  const { pathname } = useLocation();
  const metadata = getSeoMetadata(pathname);
  const robots = metadata.isIndexable
    ? "index, follow"
    : "noindex, nofollow";

  return (
    <Helmet htmlAttributes={{ lang: "th" }}>
      <title>{metadata.title}</title>
      <meta name="description" content={metadata.description} />
      <meta name="robots" content={robots} />

      {metadata.isIndexable && (
        <link rel="canonical" href={metadata.canonicalUrl} />
      )}
      {metadata.isIndexable && <meta property="og:type" content="website" />}
      {metadata.isIndexable && (
        <meta property="og:site_name" content="Assure Wealth" />
      )}
      {metadata.isIndexable && <meta property="og:locale" content="th_TH" />}
      {metadata.isIndexable && (
        <meta property="og:title" content={metadata.title} />
      )}
      {metadata.isIndexable && (
        <meta property="og:description" content={metadata.description} />
      )}
      {metadata.isIndexable && (
        <meta property="og:url" content={metadata.canonicalUrl} />
      )}
      {metadata.isIndexable && (
        <meta property="og:image" content={metadata.image} />
      )}
      {metadata.isIndexable && (
        <meta property="og:image:alt" content={metadata.imageAlt} />
      )}

      {metadata.isIndexable && (
        <meta name="twitter:card" content="summary_large_image" />
      )}
      {metadata.isIndexable && (
        <meta name="twitter:title" content={metadata.title} />
      )}
      {metadata.isIndexable && (
        <meta name="twitter:description" content={metadata.description} />
      )}
      {metadata.isIndexable && (
        <meta name="twitter:image" content={metadata.image} />
      )}
      {metadata.isIndexable && (
        <meta name="twitter:image:alt" content={metadata.imageAlt} />
      )}
    </Helmet>
  );
};

export default SeoMetadata;
